import type { PageCard } from '@/play/pageTypes'
import { MoonSlime2CardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'moon-slime-2',
  number: 32,
  title: 'Moon slime 2',
  question: 'Does Moon slime look and feel better with the materials and light the paint study found?',
  status: 'open',
  // Version 2 of 009 Moon slime: one home card (this one), flipped between in the settings panel.
  versionOf: 'moon-slime',
  accent: '#1b1f36',
  CardArt: MoonSlime2CardArt,
}
